var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_70_106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7073 23.5891C14.5743 24.137 9.42572 24.137 4.29272 23.5891C2.24597 23.3707 0.629333 21.754 0.410889 19.7071C-0.136963 14.5741 -0.136963 9.42572 0.410889 4.29272C0.629333 2.24597 2.24597 0.629333 4.29272 0.410889C9.42572 -0.136963 14.5741 -0.136963 19.7071 0.410889C21.754 0.629333 23.3707 2.24597 23.5891 4.29272C24.137 9.42572 24.137 14.5741 23.5891 19.7071C23.3707 21.754 21.7542 23.3707 19.7073 23.5891Z",
    fill: "url(#paint0_linear_70_106)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2837 5.1608C22.09 3.34457 20.6555 1.90994 18.8391 1.71603C14.2842 1.23007 9.71573 1.23007 5.1608 1.71603C3.34457 1.90994 1.90994 3.34457 1.71603 5.1608C1.23007 9.71573 1.23007 14.2842 1.71603 18.839C1.90994 20.6554 3.34457 22.09 5.1608 22.2837C9.71573 22.7699 14.2842 22.7699 18.839 22.2837C20.6554 22.09 22.09 20.6554 22.2837 18.839C22.7699 14.2842 22.7699 9.71573 22.2837 5.1608Z",
    fill: "url(#paint1_linear_70_106)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.359375 19.2096C0.375855 19.3755 0.392883 19.5414 0.410645 19.7073C0.629089 21.754 2.24573 23.3707 4.29266 23.5891C9.42566 24.137 14.574 24.137 19.707 23.5891C21.754 23.3707 23.3704 21.754 23.5889 19.7073C23.6066 19.5414 23.6237 19.3755 23.6403 19.2096H0.359375Z",
    fill: "url(#paint2_linear_70_106)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2471 6.72357C15.8548 5.33032 14.0505 4.65668 12.0779 4.65576C8.01331 4.65576 4.75256 7.91541 4.75092 11.98C4.75037 13.2793 5.18396 14.5004 5.82922 15.6183L4.59473 19.4382L9.09839 23.9417C12.6353 24.0836 16.1747 23.9661 19.7072 23.5891C21.7541 23.3706 23.3705 21.754 23.589 19.707C23.8111 17.6271 23.9429 15.5445 23.985 13.4615L17.2471 6.72357Z",
    fill: "url(#paint3_linear_70_106)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.85156 19.1808L5.86157 15.4931C5.23846 14.4139 4.91089 13.1895 4.91125 11.9354C4.9129 8.0116 8.10626 4.81934 12.03 4.81934C13.9343 4.82025 15.7218 5.56128 17.0656 6.90637C18.4098 8.25165 19.1495 10.0395 19.1488 11.941C19.1472 15.8648 15.9534 19.0574 12.0302 19.0574C12.03 19.0574 12.0304 19.0574 12.0302 19.0574H12.0271C10.8358 19.0571 9.66522 18.7581 8.62537 18.1913L4.85156 19.1808Z",
    fill: "url(#paint4_linear_70_106)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2471 6.72369C15.8548 5.33044 14.0034 4.56268 12.0308 4.56177C7.96625 4.56177 4.65845 7.86847 4.6568 11.933C4.65625 13.2324 4.99573 14.5005 5.64099 15.6184L4.59473 19.4384L8.50385 18.4133C9.58105 19.0007 10.7936 19.3102 12.0277 19.3107H12.0308C16.0948 19.3107 19.4032 16.0033 19.4048 11.9389C19.4056 9.96924 18.6393 8.11713 17.2471 6.72369ZM12.0308 18.0658H12.0284C10.9285 18.0651 9.84985 17.7697 8.90906 17.2114L8.68512 17.0787L6.36536 17.687L6.98462 15.426L6.83868 15.1942C6.2251 14.2186 5.90118 13.0912 5.90173 11.9336C5.90302 8.5553 8.65234 5.80688 12.0332 5.80688C13.6703 5.80743 15.209 6.44574 16.3664 7.6037C17.5236 8.76184 18.1603 10.3012 18.1599 11.9385C18.1584 15.3168 15.4089 18.0658 12.0308 18.0658Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3926 13.4769C15.2084 13.3848 14.3026 12.9389 14.1336 12.8774C13.9647 12.816 13.8419 12.7853 13.719 12.9698C13.5961 13.154 13.2431 13.569 13.1356 13.6918C13.0281 13.8149 12.9207 13.8302 12.7365 13.7381C12.5523 13.6457 11.9588 13.4514 11.2548 12.8237C10.7071 12.3354 10.3372 11.7322 10.2297 11.5478C10.1223 11.3635 10.2182 11.2637 10.3107 11.1717C10.3933 11.0893 10.4949 10.9568 10.587 10.8491C10.6789 10.7416 10.7097 10.6647 10.7712 10.5419C10.8325 10.4188 10.8018 10.3113 10.7558 10.2192C10.7097 10.1269 10.3517 9.21581 10.1878 8.85143C10.0497 8.54472 9.90436 8.5385 9.77307 8.53319C9.66577 8.52861 9.54273 8.52879 9.42005 8.52879C9.29718 8.52879 9.0976 8.57494 8.92877 8.75932C8.75977 8.94371 8.28369 9.38939 8.28369 10.2959C8.28369 11.2025 8.94415 12.0785 9.03607 12.2015C9.12836 12.3244 10.3109 14.2441 12.1837 14.9827C13.7401 15.5965 14.0568 15.4744 14.3947 15.4436C14.7325 15.4128 15.4847 14.9981 15.6383 14.5678C15.7918 14.1377 15.7918 13.7689 15.7458 13.6918C15.6997 13.6151 15.5768 13.569 15.3926 13.4769Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_70_106",
    x1: 5.45964,
    y1: -0.600231,
    x2: 22.7529,
    y2: 32.7158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#FAF8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4041,
    stopColor: "#ECEEF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6353,
    stopColor: "#D5DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#B5C4DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1B5D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_70_106",
    x1: 9.20494,
    y1: 10.4278,
    x2: -31.4539,
    y2: -12.4428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1B5D8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3094,
    stopColor: "#90A2BD",
    stopOpacity: 0.309804
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7554,
    stopColor: "#7C8B9C",
    stopOpacity: 0.756863
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#748290"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_70_106",
    x1: 11.9998,
    y1: 21.1859,
    x2: 11.9998,
    y2: 24.9269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1B5D8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3094,
    stopColor: "#90A2BD",
    stopOpacity: 0.309804
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7554,
    stopColor: "#7C8B9C",
    stopOpacity: 0.756863
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#748290"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_70_106",
    x1: 15.9001,
    y1: 19.0959,
    x2: 6.83675,
    y2: 4.20118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1B5D8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3094,
    stopColor: "#90A2BD",
    stopOpacity: 0.309804
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7554,
    stopColor: "#7C8B9C",
    stopOpacity: 0.756863
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#748290"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_70_106",
    x1: 12.0001,
    y1: 19.1809,
    x2: 12.0001,
    y2: 4.81932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20B038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D66A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_70_106"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.8b2c1a9dc7015cc0470ae86a3fa0ff4c.svg";
export { ForwardRef as ReactComponent };